<template>
  <div class="search-options-header">
    <div
      class="option"
      :class="[item.class]"
      v-for="(item, index) in tokenOptions"
      :key="`option-${index}`"
    >
      <span class="extra" v-if="isExtra && index === 0">#</span>
      <span>{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    isExtra: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["isMobileSize"]),
    tokenOptions() {
      const name = {
        label: this.$t("option.name"),
        class: "option_name",
      };
      const price = {
        label: this.$t("option.price"),
        class: "option_price",
      };
      const liq = {
        label: `LIQ`,
        class: "option_liq",
      };
      const vol = {
        label: `24H VOL`,
        class: "option_vol",
      };
      const fdv = {
        label: `FDV`,
        class: "option_fdv",
      };
      if (this.isMobileSize) {
        return [name, price];
      }
      return [name, price, liq, vol, fdv];
    },
  },
};
</script>

<style lang="less" scoped>
.search-options-header {
  display: flex;
  align-items: center;
  // height: 40px;
  padding: 16px 20px 0;
  .option {
    font-size: 12px;
    color: var(--color-27);
    &.option_name {
      flex: var(--search-hot-token-name);
    }
    &.option_price {
      flex: var(--search-hot-token-price);
    }
    &.option_liq {
      flex: var(--search-hot-token-liq);
    }
    &.option_vol {
      flex: var(--search-hot-token-24h-vol);
    }
    &.option_fdv {
      flex: var(--search-hot-token-fdv);
      text-align: right;
    }
    &.option_collect {
      flex: var(--search-hot-token-collect);
      text-align: right;
    }

    .extra {
      display: inline-block;
      width: 20px;
    }
  }
}
@media screen and (max-width: 680px) {
  .search-options-header {
    .option {
      &.option_price {
        display: flex;
        justify-content: flex-end;
      }
      // &.option_collect {
      //   flex: var(--search-hot-token-collect);
      //   text-align: right;
      // }
      
      .extra {
        width: 30px;
      }
    }

  }
}
</style>
